
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/design-system/typography",
      function () {
        return require("private-next-pages/design-system/typography.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/design-system/typography"])
      });
    }
  